import { Namespace } from '@36node-fcp/auth-sdk';
import { Gantry } from '@36node-fcp/core-sdk';
import dayjs from 'dayjs';
import { useMemo } from 'react';

import { AdColumnsType, AdTable } from 'src/components/antd/ad-table';
import { ExportModal } from 'src/components/xlsx-export-modal';
import { IllegalHandleResultUiList } from 'src/features/illegal';
import { GantryReportItem, useGantryReport } from 'src/features/illegal-handle-report';
import { useSlice } from 'src/lib/react-slice';

import SearchForm from './illegal-handle-search.form';
import { useReportSearch } from './illegal-handle.context';

type State = {
  exportVisible: boolean;
};

const initState: State = {
  exportVisible: false,
};
const reducers = {
  openExport(state: State) {
    state.exportVisible = true;
  },
  closeExport(state: State) {
    state.exportVisible = false;
  },
};

/**
 * 总报表
 */
const BasicReport: React.FC = () => {
  const [{ exportVisible }, dispatch] = useSlice(reducers, initState);
  const [, search] = useReportSearch();
  const [{ loading, result }] = useGantryReport(search);

  const columns = useMemo<AdColumnsType<GantryReportItem>>(() => {
    return [
      {
        title: '卡口',
        dataIndex: 'gantry',
        compute: (val: Gantry) => val.name,
      },
      {
        title: '部门名',
        dataIndex: 'ns',
        compute: (val: Namespace) => val.name,
      },

      {
        title: '违法数',
        dataIndex: 'illegalCount',
      },
      {
        title: '处置完成数',
        dataIndex: 'illegalHandleClosedCount',
      },
      {
        title: IllegalHandleResultUiList[0].text,
        dataIndex: 'illegalHandleResult1Count',
      },
      {
        title: IllegalHandleResultUiList[1].text,
        dataIndex: 'illegalHandleResult2Count',
      },
      {
        title: IllegalHandleResultUiList[2].text,
        dataIndex: 'illegalHandleResult3Count',
      },
      {
        title: IllegalHandleResultUiList[3].text,
        dataIndex: 'illegalHandleResult4Count',
      },
      {
        title: IllegalHandleResultUiList[4].text,
        dataIndex: 'illegalHandleResult5Count',
      },
      {
        title: IllegalHandleResultUiList[5].text,
        dataIndex: 'illegalHandleResult6Count',
      },
      {
        title: IllegalHandleResultUiList[6].text,
        dataIndex: 'illegalHandleResult7Count',
      },
    ];
  }, [search]);

  return (
    <>
      <AdTable
        bordered
        columns={columns}
        title={<div>总报表（{result.length}）</div>}
        rowKey="uniqKey"
        loading={loading}
        scroll={{ x: 'max-content' }}
        dataSource={result}
        showColumnsFilter={false}
        onExport={dispatch.openExport}
        pagination={false}
        extraTools={<SearchForm />}
      />
      {exportVisible && (
        <ExportModal
          dataSource={result}
          columns={columns}
          filename={`违法处置统计-总报表${dayjs().format('YYYY-MM-DD')}.xlsx`}
          onClose={dispatch.closeExport}
          title="违法处置统计-总报表"
          total={result.length}
        />
      )}
    </>
  );
};

export default BasicReport;
